import { Button } from 'antd';

import { Arrow, IconCommunity } from '../../../Common/Icon';

import styles from './index.module.scss';
import Card from './Card';
import { CSSProperties, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InfiniteSlider from './InfiniteSlider';

export interface Rewiew {
  id: string;
  logoSrc: string;
  businesses: {
    name: string;
    city: string;
    country: string;
  };
  description: string;

  user: {
    photo: string;
    name: string;
    country: string;
    category: string;
  };
}

const rewiews: Rewiew[] = [
  {
    id: '1',
    logoSrc: '/media/rewiewLogo.png',
    businesses: {
      name: 'Perfect Paws Pet Grooming',
      city: 'Denver',
      country: 'CO',
    },
    description:
      "I took my terrier in for a grooming and was asked to leave a 20%, 25%, or 30% tip at drop off! Pet owners, aren't we supposed to tip AFTER the service is complete?",
    user: {
      photo: '/media/rewiewLogo.png',
      name: 'Jennyjogger23',
      country: 'US',
      category: '🚙',
    },
  },
  {
    id: '2',
    logoSrc: '/media/rewiewLogo.png',
    businesses: {
      name: 'Blue Lotus Nails',
      city: 'Hartford',
      country: 'CT',
    },
    description:
      "I'm never sure if I need to tip more if I get a fancy design on my manicure. They charged me an extra $5 for each flower, so a $40 manicure service quickly turned into a $70 bill. Am I supposed to tip on the $70?",
    user: {
      photo: '/media/rewiewLogo.png',
      name: 'Lucybeautylover',
      country: 'US',
      category: '🚙',
    },
  },
  {
    id: '3',
    logoSrc: '/media/rewiewLogo.png',
    businesses: {
      name: 'Lucky Gator Casino',
      city: 'Tallahassee',
      country: 'FL',
    },
    description:
      "I'm planning a Vegas trip with some buddies next month, and none of us have gambled before.  Are we supposed to be tipping the Jackpot attendants? Just a few extra bucks or a percentage of our winnings? TYSM!",
    user: {
      photo: '/media/rewiewLogo.png',
      name: 'Tom_trucker',
      country: 'US',
      category: '🚙',
    },
  },
  {
    id: '4',
    logoSrc: '/media/rewiewLogo.png',
    businesses: {
      name: "Bob's BBQ",
      city: 'Kentwood',
      country: 'MI',
    },
    description: 'Their tip screen options go up to 35%. Not going back there.',
    user: {
      photo: '/media/rewiewLogo.png',
      name: 'TinyTina',
      country: 'US',
      category: '🚙',
    },
  },
  {
    id: '5',
    logoSrc: '/media/rewiewLogo.png',
    businesses: {
      name: 'Uptown Luggage Repair',
      city: 'Conway',
      country: 'AR',
    },
    description:
      "Can't believe a luggage repair place has a tip screen. It was already expensive enough.",
    user: {
      photo: '/media/rewiewLogo.png',
      name: 'WildPheasant3',
      country: 'US',
      category: '🚙',
    },
  },
  {
    id: '6',
    logoSrc: '/media/rewiewLogo.png',
    businesses: {
      name: 'Tuscany Refrigerator Repair',
      city: 'Carlsbad',
      country: 'CA',
    },
    description:
      'This refrigerator repair company put a tip screen in my face after swiping my credit card. Not going with this company again. Tired of seeing tip screens for everything.',
    user: {
      photo: '/media/rewiewLogo.png',
      name: 'TunaSeeker349',
      country: 'US',
      category: '🚙',
    },
  },
];

const TrendingOnTippingGuide = () => {
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(0);
  const [sliderWrapperStyle, setSliderWrapperStyle] = useState<CSSProperties>({
    padding: 0,
  });

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    const onresize = (w: any) => setWindowWidth(w.target.innerWidth);
    window.addEventListener('resize', onresize);

    return () => {
      window.removeEventListener('resize', onresize);
    };
  }, []);

  useEffect(() => {
    let newPadding = 0;
    if (windowWidth > 1440) {
      newPadding = (windowWidth - 1280) / 2;
    } else if (windowWidth > 768) {
      newPadding = 80;
    } else {
      newPadding = 20;
    }
    setSliderWrapperStyle({ padding: `0 ${newPadding}px` });
  }, [windowWidth]);

  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.content}>
            <h2 className={styles.title}>
              <span>
                <span className="colorGreen">Trending</span> on
              </span>{' '}
              <span>Tipping Guide</span>
            </h2>
            <div className={styles.innerWrapper}>
              <p className={styles.description}>
                See what your peers are saying about tipping and service fees at{' '}
                <span className={styles.bold}>
                  real businesses in your area!
                </span>
              </p>
              <Button
                className={styles.button}
                icon={<IconCommunity />}
                type="primary"
                onClick={() => navigate('/share-your-two-cents')}
              >
                View All Posts
              </Button>
            </div>
          </div>
        </div>
      </div>

      <InfiniteSlider reviews={rewiews} />
    </div>
  );
};

export default TrendingOnTippingGuide;
